export default function nucleusFormErrorMessage(componentName) {
  return new Error(
    `Could not find "nucleusForm" in either the context or props of
     "${componentName}". Either wrap the component in a <Form>,
     or explicitly pass "nucleusForm" as a prop to  "${componentName}".`);
}
